(function(){
  'use strict';
  if(window.__PMY_CITY_EXPLORE_2026__)return;
  window.__PMY_CITY_EXPLORE_2026__=true;

  var I18N={
    en:{eyebrow:'Explore by City',prefix:'Experiences in',one:'experience',many:'experiences'},
    pt:{eyebrow:'Explore por Cidade',prefix:'Experiências em',one:'experiência',many:'experiências'},
    es:{eyebrow:'Explora por Ciudad',prefix:'Experiencias en',one:'experiencia',many:'experiencias'},
    fr:{eyebrow:'Explorer par Ville',prefix:'Expériences à',one:'expérience',many:'expériences'},
    de:{eyebrow:'Nach Stadt entdecken',prefix:'Erlebnisse in',one:'Erlebnis',many:'Erlebnisse'},
    it:{eyebrow:'Esplora per Città',prefix:'Esperienze a',one:'esperienza',many:'esperienze'},
    nl:{eyebrow:'Ontdek per Stad',prefix:'Ervaringen in',one:'ervaring',many:'ervaringen'},
    ar:{eyebrow:'استكشف حسب المدينة',prefix:'تجارب في',one:'تجربة',many:'تجارب'},
    he:{eyebrow:'גלו לפי עיר',prefix:'חוויות ב',one:'חוויה',many:'חוויות'}
  };

  function lang(){
    var raw=(document.documentElement.lang||'en').toLowerCase();
    var key=raw.indexOf('pt')===0?'pt':raw.slice(0,2);
    return I18N[key]||I18N.en;
  }

  function norm(v){
    return String(v||'').trim().toLocaleLowerCase();
  }

  function productCards(root,city,destination){
    var wanted=norm(city),seen={},out=[];
    root.querySelectorAll('.pmy-home-product-card[data-pmy-location]').forEach(function(card){
      var location=norm(card.getAttribute('data-pmy-location'));
      var cityHref=(root.querySelector('.pmy-home-city-card[data-pmy-city="'+city+'"]')||{}).href||'';
      var productHref=card.getAttribute('data-pmy-product-url')||'';
      var sameProduct=!!(cityHref&&productHref&&cityHref.split('?')[0].split('/').pop()===productHref.split('?')[0].split('/').pop());
      var cityMatch=location===wanted || location.split(/[,;|\/]/).map(norm).indexOf(wanted)!==-1 || (destination==='italy' && (location.indexOf(wanted)!==-1 || sameProduct));
      if(!cityMatch)return;
      if((card.getAttribute('data-pmy-card-destination')||'portugal')!==destination)return;
      var url=card.getAttribute('data-pmy-product-url')||
        (card.querySelector('a[href*="/products/"]')&&card.querySelector('a[href*="/products/"]').getAttribute('href'))||
        '';
      var key=url||card.textContent.trim();
      if(seen[key])return;
      seen[key]=true;
      out.push(card);
    });
    return out;
  }

  function init(root){
    var section=root.querySelector('.pmy-home-cities-section');
    if(!section||section.dataset.pmyCityExploreInit==='1')return;
    section.dataset.pmyCityExploreInit='1';

    var rail=section.querySelector('.pmy-home-city-rail');
    var shell=section.querySelector('.pmy-home-shell');
    if(!rail||!shell)return;

    var result=document.createElement('div');
    result.className='pmy-home-city-results';
    result.hidden=true;
    result.innerHTML=
      '<div class="pmy-home-city-results__head">'+
        '<div class="pmy-home-city-results__copy">'+
          '<span class="pmy-home-city-results__eyebrow"></span>'+
          '<h3 class="pmy-home-city-results__title"></h3>'+
        '</div>'+
        '<button type="button" class="pmy-home-city-results__close" aria-label="Close">×</button>'+
      '</div>'+
      '<div class="pmy-home-city-results__grid"></div>';

    rail.insertAdjacentElement('afterend',result);

    var eyebrow=result.querySelector('.pmy-home-city-results__eyebrow');
    var title=result.querySelector('.pmy-home-city-results__title');
    var grid=result.querySelector('.pmy-home-city-results__grid');
    var close=result.querySelector('.pmy-home-city-results__close');
    var copy=lang();
    eyebrow.textContent=copy.eyebrow;

    function cardsFor(city,destination){
      return productCards(root,city,destination);
    }

    function updateCounts(){
      section.querySelectorAll('.pmy-home-city-card[data-pmy-city]').forEach(function(cityCard){
        var city=cityCard.getAttribute('data-pmy-city')||'';
        var destination=cityCard.getAttribute('data-destination')||'portugal';
        var count=cardsFor(city,destination).length;
        var badge=cityCard.querySelector('.pmy-home-city-card__count');
        if(!badge){
          badge=document.createElement('span');
          badge.className='pmy-home-city-card__count';
          cityCard.appendChild(badge);
        }
        badge.textContent=count+' '+(count===1?copy.one:copy.many);
      });
    }

    function collapse(){
      result.hidden=true;
      grid.innerHTML='';
      section.querySelectorAll('.pmy-home-city-card[aria-expanded="true"]').forEach(function(c){
        c.setAttribute('aria-expanded','false');
      });
    }

    function openCity(card){
      var city=card.getAttribute('data-pmy-city')||'';
      var destination=card.getAttribute('data-destination')||'portugal';
      var cards=cardsFor(city,destination);

      if(!cards.length){
        var href=card.getAttribute('href');
        if(href)window.location.href=href;
        return;
      }

      var alreadyOpen=card.getAttribute('aria-expanded')==='true'&&!result.hidden;
      collapse();
      if(alreadyOpen)return;

      card.setAttribute('aria-expanded','true');
      title.textContent=copy.prefix+' '+city;

      cards.forEach(function(source){
        var clone=source.cloneNode(true);
        clone.removeAttribute('id');
        clone.removeAttribute('hidden');
        grid.appendChild(clone);
      });

      result.hidden=false;

      requestAnimationFrame(function(){
        var top=result.getBoundingClientRect().top+window.scrollY-110;
        if(window.scrollY>top||result.getBoundingClientRect().bottom>window.innerHeight){
          window.scrollTo({top:Math.max(0,top),behavior:'smooth'});
        }
      });
    }

    section.addEventListener('click',function(e){
      var card=e.target.closest('.pmy-home-city-card[data-pmy-city]');
      if(!card||!section.contains(card))return;
      e.preventDefault();
      openCity(card);
    });

    close.addEventListener('click',collapse);
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'&&!result.hidden)collapse();
    });

    window.addEventListener('pmy:destination-change',function(){
      collapse();
      setTimeout(updateCounts,0);
    });
    document.addEventListener('pmy:country-change',function(){
      collapse();
      setTimeout(updateCounts,0);
    });

    updateCounts();
  }

  function boot(){
    document.querySelectorAll('.pmy-home-2026').forEach(init);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();

  document.addEventListener('shopify:section:load',function(e){
    var root=e.target&&e.target.querySelector&&e.target.querySelector('.pmy-home-2026');
    if(root)init(root);
  });
})();